var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header"},[(_vm.card.category)?_c('CardCategory',{attrs:{"category":_vm.card.category}}):_vm._e(),_c('div',{staticClass:"card-header__heading"},[_c('AppHeading',{staticClass:"card-header__title",attrs:{"tag":"h2","text":_vm.card.title}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }